/**
 * Created by ziv on 7/12/16.
 */

import React from 'react';
import UserDetails from '../components/UserDetails';
import SectorsPie from '../components/SectorsPie';
import BudgetAllocationControls from '../components/BudgetAllocationControls';
import SectorCard from '../components/SectorCard';
import HeaderBG from '../components/HeaderBG';
import HomeHeader from '../components/HomeHeader';
import SectorsTable from '../components/SectorsTable';
import BacktestModule from "../components/BacktestModule";
import BuildHeader from '../components/BuildHeader'
// sector selection
import GridList from 'material-ui/GridList';
import Checkbox from 'material-ui/Checkbox';
import Paper from 'material-ui/Paper';
import LinearProgress from 'material-ui/LinearProgress';
import { browserHistory } from 'react-router'; // notice I'm importing from 'react-router'


import BuildStore from '../store/BuildStore';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import BuildApi from '../actions/BuildApi';
import ResponseMessage from '../components/ResponseMessage'
import ErrorView from '../components/ErrorView'
// import Auth from '../actions/Auth'
import {filter,cloneDeep,clone} from 'lodash';
import {numberToPercentage} from '../lib/utils'
import List from 'material-ui/List';
import {observer} from 'mobx-react';
import {Router} from 'react-router';
import MenuItem from 'material-ui/MenuItem';
import DropDownMenu from 'material-ui/DropDownMenu';
// import {percentageRangeCheck} from '../lib/utils'
import NotificationSystem from 'react-notification-system'

var numeral = require('numeral');

const periodOptions = [
	{type:1,name:'1 Month'},
	{type:2,name:'2 Months'},
	{type:3,name:'3 Months'},
	{type:4,name:'4 Months'},
	{type:5,name:'5 Months'},
	{type:6,name:'6 Months'},
	{type:7,name:'7 Months'},
	{type:8,name:'8 Months'},
	{type:9,name:'9 Months'},
	{type:10,name:'10 Months'},
	{type:11,name:'11 Months'},
	{type:12,name:'12 Months'},
]

const paperStyle = {
	marginTop: 1,
	padding: 15,
	    //display: 'flex',
    flexDirection: 'row wrap',
    width: '100%',
    boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
};


const leftTitleStyle ={

	fontWeight: 'bold',
	fontFamily:'Roboto',
	marginBottom: 15,
	marginLeft: '0.8%',
	color:'rgb(92, 95, 103)'
	//flex:2
}
const bigTitleStyle ={
	marginBottom: 15,
	marginLeft: '0.8%',
	color:'#3D404A',
	fontSize:'24px',
	fontWeight:'100',
	marginTop:'30px',
}

const gListStyle ={
	//flex:7
}
const hrStyle ={
	backgroundColor:'#3D404A',
	border:'none',
	width:'98%',
}
const styles = {

	background:{
		backgroundImage:'url("../../img/bg_repeat-x.jpg")',
		backgroundRepeat:'repeat-x',
	},
	topRowRoot:{
	    display: 'flex',
	    flexDirection: 'row wrap',
	    width: '100%',
	    marginTop:70,
  	},
	userDetails:{
	    flex: 4,
	    height: '100%',
	    marginLeft: 10,
	    marginRight:10,
	    // textAlign: 'center',
	    // padding: 10,
  		// width: 470,
	},
	sectorsPie:{

		marginRight:10,
		height:337
	    // marginLeft: 10,
	},
	sectorsTable:{
		// marginRight:10,
		width:'100%',
		padding:10,
		paddingBottom:0,
		// maxHeight:330
	},
	errors:{
		width:'100%',
		padding:10,
		paddingTop:0,
	},
	rightCol:{
		flex:4
	},
	cbTitle:{
		width: '15%',
		flex:1
	},
	budgetPaper:{
		// marginTop:10,
		boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
	},
	cardsContainer:{
		width: '100%',
		// padding:5,
		marginTop:0,
	},
	outerDiv:{
		width:'80%',
		marginLeft:'10%',
		paddingBottom:'50px',
		minWidth:'1150px',
	},
	buttonLabel:{
		fontFamily:'Roboto',
		fontSize:'10px !important',
		fontWeight:'300',
		textTransform:'none !important'
	},
	secButton:{
		selected:{

			height:31,
			lineHeight:'30px',
			width:'100%',
			whiteSpace:"nowrap",
			backgroundColor:'#5C5F67',
			color:'#E0E0E0',
			fontWeight:'300',
		},
		unselected:{
			height:31,
			lineHeight:'30px',
			width:'100%',
			whiteSpace:"nowrap",
			backgroundColor:'#E0E0E0',
			color:'#5C5F67',
			fontWeight:'300',
		},
	},
	// checkbox:{
	// 	fontSize:13,
	// 	whiteSpace:"nowrap",
	// },
	// checkboxIcon:{
	// 	marginRight:5,
	// 	height:20,
	// },
	sectorsList:{
		padding:0,
		// display:'inline'
	},
	sectorCard:{
		width:"50%",
		float:'left',
	},
	create_paper:{
		// marginTop: 10,
		marginBottom: 10,
		// padding: 15,
		    //display: 'flex',
		height:60,
	    flexDirection: 'row wrap',
	    width: '100%',
	    boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
	},
	datePickerPaper:{
			padding:10,
			marginBottom: 10,
		    flexDirection: 'row wrap',
		    width: '100%',
		    boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
	},
	button:{
		margin: 12,
		flex: 1.2,
	    // lineHeight: 4,
	    height: 35,
	},
	updateTeamButton:{
			margin: 12,
			flex: 4,
		    fontFamily:'Roboto',
		    height: 35,
	},
	monthsDropdown:{
		flex: 3,
		maxWidth:'160px',
	},
	periodSelectText:{
		padding: '20px 10px',
		paddingRight:0,
		textAlign: 'right',
		flex:2,
	},
	resMessage:{
		flex:4,
		margin:3
	},
	linearProgress:{
		height:3,
		position:'fixed',
	},
	notLoggedIn:{
		color: 'red',
		fontSize: 24,
		position: 'absolute',
		marginTop: '7%',
		width: '100%',
		textAlign: 'center',
		fontFamily:'Roboto',
	},
	buildFooter:{
		height:50,
		position:'fixed',
		bottom:0,
		width:'100%',
		backgroundColor:'black',
		textAlign:'right',
		zIndex:100,
	},

	bTButton:{
		margin: 12,
		flex: 1,
	    lineHeight: '31px',
	    height: 35,
	    borderStyle:'solid',
	    borderWidth:1,
	    borderColor:'lightblue',
	    color:'lightblue',
	    borderRadius:2
	},
	sButton:{
		margin: 12,
		flex: 1,
	    lineHeight: '31px',
	    height: 35,
	    borderStyle:'solid',
	    borderWidth:1,
	    borderColor:'lightgreen',
	    color:'lightgreen',
	    borderRadius:2
	},
	backtestArea:{
		position:'fixed',
		height:340,
		bottom:50,
		width:'100%',
		backgroundColor:'black',
		zIndex:100,
		visibility:'hidden',
		paddingLeft:'10%',
		borderBottom:'1px solid gray',
	}

};

var pData =  [
  {label: 'Margarita', value: 20.0},
  {label: 'John', value: 55.0},
  {label: 'Tim', value: 25.0 }
];
let _notificationSystem = null
//@observer
@observer(['state','actions'])
export default class Build extends React.Component {

	// componentWillMount(){
	// 	const self = this

	// }

	// componentDidMount(){
	// 	this._notificationSystem = this.refs.notificationSystem;
	// }
	componentDidUpdate(){
		if(null == _notificationSystem){
			_notificationSystem = this.refs.notificationSystem;
		}
	}
	componentWillMount(){
		const self = this
		// console.log( )
		// console.log(this.props.actions.auth.isLogged())

		// ziv for debug
		if(window.location.port == 3005){
			self.setState({login:true})
			BuildStore.getSectors()
			setTimeout(function(){
				self.validateSectors()
			},200)
			return
		}
		this.props.actions.auth.isLogged().then(function(res){

			console.log(res)
			if(!res.data){
				console.log("lililii")
				// self.context.router.push('/home');

				// browserHistory.push('/#/home');
				self.setState({login:false})
			}else{
				self.setState({login:true})
			}
			// console.log(" logged in")
		},function(err){
			console.log("not logged in")
			browserHistory.push('/#/home');
		})

		console.log("track page build");
		window.analytics.page('Build');
		BuildStore.getSectors().then(function(res){
			self.validateSectors()
		})

		// console.log(percentageRangeCheck(20))

	}

	static get contextTypes() {
	    return {
	      router: React.PropTypes.object.isRequired,
	    };
	  }

	constructor(props, context) {
	    super(props, context);
	    this.state ={
	    	showBacktest:false,
	    	errors:[],
	    	alerts:[],
	    	login:false
	    }
 	}

  	// addNotification = () => {
	  //   // event.preventDefault();
	  //   this._notificationSystem.addNotification({
	  //     message: 'Notification message',
	  //     level: 'success',
	  //     position: 'br',
	  //   })

  	// }
 	duplicateScreener = (screener, originSectorName) => {

 		this.removeSimilerScreeners(screener, originSectorName)
 		//this.forceUpdate();
 		var updatedSects = BuildStore.sectors.map(function(d) {
	    	var sec = d;
	    	if(sec.name != originSectorName){
	    		var screenerCopy = clone(screener)
	    		sec.screeners.push(screenerCopy);

	    	}
	    	return sec;
	    });
 		// console.log(updatedSects)
 		BuildStore.sectors.replace(updatedSects)
	    // this.setState({sectors:updatedSects});
 	};

 	removeSimilerScreeners = (screener, originSectorName) =>{

 		var updatedSects = BuildStore.sectors.map(function(d) {
	    	var sec = d;
	    	if(sec.name != originSectorName){

	    		var screenersCopy = clone(sec.screeners)
	    		// console.log(screener)
	    		if(screener.pos_type == 2 || screener.pos_type == '2'){
	    			// console.log("lilililili")
	    			var screenersCopy = filter(sec.screeners,function(o) { return !(o.field == screener.field); } )
	    		}
	    		else{
	    			// console.log("lululululu")
	    			// console.log(screener.pos_type)
	    			var screenersCopy = filter(sec.screeners,function(o) { return !(o.field == screener.field && (o.pos_type == screener.pos_type || o.pos_type == 2) ); } )
	    		}
	    		console.log(screenersCopy)
	    		sec.screeners.replace(screenersCopy)
	    		//

	    	}
	    	return sec;
	    });
 		BuildStore.sectors.replace(updatedSects)
	    // this.setState({sectors:updatedSects});
 	}

 	duplicateStrategy = (strategy, originSectorName) => {

 		this.removeSimilerStrategies(strategy, originSectorName)
 		var updatedSects = BuildStore.sectors.map(function(d) {
	    	var sec = d;
	    	if(sec.name != originSectorName){

	    		var strategyCopy = clone(strategy)
	    		sec.strategies.push(strategyCopy);
	    		// sec.strategies.push(strategy);
	    	}
	    	return sec;
	    });

	    this.setState({sectors:updatedSects});
 	};

 	removeSimilerStrategies = (strategy, originSectorName) =>{

 		var updatedSects = BuildStore.sectors.map(function(d) {
	    	var sec = d;
	    	if(sec.name != originSectorName){

	    		var strategyCopy = clone(sec.strategies)
	    		console.log(strategy.field)
	    		var strategiesCopy = filter(sec.strategies,function(o) { return !(o.field == strategy.field); } )
	    		console.log(strategiesCopy)
	    		sec.strategies.replace(strategiesCopy)
	    	}
	    	return sec;
	    });
 		BuildStore.sectors.replace(updatedSects)
	    // this.setState({sectors:updatedSects});
 	};

	onTotalInput(val) {
	    // console.log(val,typeof val)
	    this.reAllocateBudget(val);
	};

	allocationHandler(val){

		const self = this
		// var data = {}
		// var sectorNames = []
		// var sectors = BuildStore.sectors
		// var result = false
		// sectors.forEach(function(s){
		// 	sectorNames.push(s['name'])
		// })

		// data["sectors"] = sectorNames
		// data["allocation"] = val
		// data["budget"] = BuildStore.totalSize


		// BuildApi.getAllocation(data).then(function(res){

		// 	result = res
		// 		// console.log(s)

		// 	// console.	log(self.sectors)
		// },function(err){
		// 	console.log(err)
		// })

		// if(result)
		// 	BuildStore.sectors.map(function(s) {
		//     	s.size = result[s.name]
		//         return s;
		//     });
		BuildStore.allocation = val
		BuildStore.fetchAllocation().then(function(res){
			self.validateSectors()
		})


	    // console.log(BuildStore.sectors)
	    // console.log("lilili")
		// this.reAllocateBudget(BuildStore.totalSize)
	}


// resets sectors
	reAllocateBudget(newTotal){

		// console.log(newTotal)
		// BuildStore.totalSize = newTotal
		var portion = newTotal / 10;
		// console.log('reallocating, portion ', portion, 'total', newTotal);
		var updatedSects = BuildStore.sectors.map(function(d) {
			if(!portion)
				d.size =0
			else{
	    		d.size = portion.toFixed(2);
	    		d.sizePercentage = numeral( numberToPercentage(portion,newTotal) ).format('0.[00]')
	    		console.log(d.size)
			}

	    	d.selected = true;
	        return d;
	    });
	    BuildStore.sectors.replace(updatedSects)
	    console.log(newTotal);
	    BuildStore.totalSize = newTotal
	    this.validateSectors()
	    // var state = this.state;
	    // state.total = newTotal;
	    // state.sectors = updatedSects;
	    // this.setState(state);
	}

	changePeriod(event,index,value){
		const e = event;
		e.preventDefault();


		console.log('onChange',e, value);
		BuildStore.userDetails.teamUpdatePeriod = value
		this.forceUpdate()
	}

	validateSectors(){

		// console.log("validate")
		var validate = true
		var errorMsg = ""
		var errorArr = []
		var alerts = []
		var sectorsSum = 0
		BuildStore.sectors.map(function(sector){

			errorArr = errorArr.concat(sector.validate())

			if(sector.selected){
				sectorsSum += Number(sector.size)
			}
			if(!sector.validateEtf()){

			    alerts.push("Alert: ETF size of "+sector.name+" should be between 0-100")
			}
			// validate = !sector.validate()
			// errorMsg = sector.validate()
			// if(errorMsg){
			// 	errorArr.push(errorMsg)
			// }

			// if(validate){
			// 	validate = !sector.validate()
			// }
		})
		// 4 = x/(200/100)

		// console.log(Number(sectorsSum))
		// console.log(Number(BuildStore.totalSize))

		if(Number(sectorsSum) > Number(BuildStore.totalSize)+1){
			var exceedPercent = numeral((sectorsSum-BuildStore.totalSize)/(BuildStore.totalSize/100) ).format('0.[00]')
			errorArr.push('Error: You have exceeded your budget by '+exceedPercent+'%')

		}else if(Number(sectorsSum)+1 < Number(BuildStore.totalSize)){
			var exceedPercent = numeral((BuildStore.totalSize-sectorsSum)/(BuildStore.totalSize/100) ).format('0.[00]')
			alerts.push('Alert: You have '+exceedPercent+'% left in cash')
		}
		// console.log(errorArr)
		if(errorArr.length > 0){
			errorMsg = "invalid properties check table below"
			console.log(errorArr)
			validate = false

		}
		this.setState({errors:errorArr,alerts:alerts})
		return {'valid':validate,'msg':errorMsg}

	}

	editSectors = () => {
		// this.addNotification()
		console.log("edit sectors")
		const validObj = this.validateSectors()
		if(validObj.valid){
			// console.log("====edit sectors")
			BuildStore.editSectors().then(function(res){
				_notificationSystem.addNotification({
					title: 'Great Success!',
			      	message: 'Changes to portfolio have been saved',
			      	level: 'success',
			      	position: 'br',
			    })
			}, function(err){
				console.log("promise result: ", err)
			})
		}else{
			_notificationSystem.addNotification({
				title: 'Oops!',
		      	message: 'Invalid parameters. Please fix and try again',
		      	level: 'error',
		      	position: 'br',
		    })
			BuildStore.buildStatus = "error"
			BuildStore.buildMessage = validObj.msg//"editing portfolio..."
			// console.log("error validating")
		}
		this.forceUpdate();

	}

	updateTeam(){
		console.log('update team')
		BuildStore.updateTeam().then(
			function(res){
				if(res.res_code == 301){
					// let sectorsStr = "<strong>" + res.sectors.join() + "</strong>"
					let msg = "Analyst team successfully updated for sectors: " + res.sectors.join()
					_notificationSystem.addNotification({
						title: 'Great Success!',
				      	message: msg,
				      	level: 'success',
				      	position: 'bc',
				      	allowHTML: true,
				    })
				}else{
					_notificationSystem.addNotification({
						title: 'Oops!',
				      	message: "Couldn't update analyst team, error: sectors are not defined",
				      	level: 'error',
				      	position: 'bc',
			    	})
			    }
			},
			function(err){
		    	_notificationSystem.addNotification({
					title: 'Oops!',
			      	message: 'An error occured while trying to update analysts, please try again',
			      	level: 'error',
			      	position: 'bc',
			    })
	    	}
		)
	}

	setUpdatePeriod(){
		console.log('set update period')
	}

	openBacktest(){
		styles.backtestArea.visibility = 'visible'
		this.setState({showBacktest:true})
	}

	closeBacktest(){
		styles.backtestArea.visibility = 'hidden'
		this.setState({showBacktest:false})
	}

	createSectors(){
		BuildStore.createSectors
	}

	__changeSelection(name) {

	    var updatedSects = BuildStore.sectors.map(function(d) {
	    	var cur = d;
	    	d.selected = (d.name === name ? !d.selected : d.selected);
	        return d;
	    });

	    // var state = this.state;
	    BuildStore.sectors = updatedSects
	    this.validateSectors()
	    // this.setState(state);
	};

	editSector = (sector) => {
		// console.log("editSector", sector)
		var sectors = [];
		for (var i = BuildStore.sectors.length - 1; i >= 0; i--) {
			sectors[i] = BuildStore.sectors[i]
			if(BuildStore.sectors[i].name === sector.name ){

				sectors[i].etf = sector.etf;
				sectors[i].size = sector.size;
				sectors[i].stopLoss = sector.stopLoss;
				sectors[i].isTrailing = sector.isTrailing;
				sectors[i].positionPrice = sector.positionPrice;
				sectors[i].targetPercentage = sector.targetPercentage;
				sectors[i].targetAmount = sector.targetAmount;

			}
		}
		this.validateSectors()
		this.setState({sectors:sectors});
		// console.log("editSector", this.state);

	};


	render(){

		// Auth.isLogged().then(function(res),function(err))

		const errorsStyle = Object.assign(styles.errors,(this.state.errors.length != 0 || this.state.alerts.length != 0 ? {display:'block'} : {display:'none'}) )

		// var rButtons = BuildStore.sectors.map(function(sector) {
  //           return  <Checkbox  style={styles.checkbox} iconStyle={styles.checkboxIcon} labelStyle={styles.checkbox} key={sector.name}
  //           checked={sector.selected} label={sector.name} onCheck={this.__changeSelection.bind(this,sector.name)} />;
  //       }.bind(this));
        var rButtons = BuildStore.sectors.map(function(sector) {
            return  <FlatButton style={sector.selected ? styles.secButton.selected : styles.secButton.unselected }
            labelStyle={styles.buttonLabel} key={sector.id}
            label={sector.name} onClick={this.__changeSelection.bind(this,sector.name)} />;
        }.bind(this));
		BuildStore.sectors
		var sectorCards = BuildStore.sectors.map(function(sector){
			return(<div key={sector.id} >
						<SectorCard sector={sector} userDetails={BuildStore.userDetails} totalBudget={BuildStore.totalSize} removeSimilerStrategies={this.removeSimilerStrategies} duplicateStrategy={this.duplicateStrategy} removeSimilerScreeners={this.removeSimilerScreeners} duplicateScreener={this.duplicateScreener} save={this.editSector}/>
					</div>);
		}.bind(this));

		// var bakctestOpt =   <Paper zDepth={2}  style={styles.datePickerPaper}>
		// 						<BacktestModule backtestStatusMsg={BuildStore.backtestStatusMsg} backtestStatusCode={BuildStore.backtestStatusCode} backtestResponse={BuildStore.backtestResponse} BuildStore={BuildStore} closeBacktest={this.closeBacktest.bind(this)}/>
		// 					</Paper>

		if(this.state.login === ""){
			return (<div></div>)
		}
		else if(!this.state.login ){
			return (<div>
				<HomeHeader hideLogin={true} stayOpaque={true}  style={{'backgroundColor':'#21201d'}}></HomeHeader>
				<HeaderBG></HeaderBG>
				<div style={styles.notLoggedIn}>User is not logged in</div>
				</div>)
		}
		else{
			var periodOpt = periodOptions.map(function(type){
				return <MenuItem key={type.type} id={type.type} value={type.type} primaryText={type.name} />
			});
			var change = 1;
			return (

				<div style={styles.background} className="build-pf-container">
					<HomeHeader hideLogin={true} style={{'backgroundColor':'black', height:64, minHeight:64}} fontColor={'rgb(92, 95, 103)'} stayOpaque={true} logo={require("../../img/logo-basic.png")}></HomeHeader>
					<HeaderBG></HeaderBG>
					<LinearProgress color="#ff743d" style={Object.assign(styles.linearProgress,{display:BuildStore.barProgress==0 ? 'none' : 'block'})} mode="determinate" value={BuildStore.barProgress} />
					<BuildHeader userDetails={BuildStore.userDetails}/>
					<div className="build-pf" style={styles.outerDiv}>
						<div className="home_main"></div>
						<div style={styles.topRowRoot}>
							<div style={styles.userDetails}>

								{
									// <Paper zDepth={2}  style={styles.create_paper}>
									// 								<div style={{display:'flex'}}>
									// 									<RaisedButton style={styles.button} label="backtest" onClick={this.openBacktest.bind(this)}></RaisedButton>
									// 									<RaisedButton style={styles.button} label="save" onClick={this.editSectors.bind(this)}></RaisedButton>
									// 									<ResponseMessage style={styles.resMessage} message={BuildStore.buildMessage} status={BuildStore.buildStatus}></ResponseMessage>



									// 								</div>
									// 							</Paper>



									// {this.state.showBacktest ? bakctestOpt : null}
								}
								<Paper zDepth={2}  style={styles.budgetPaper}>
									<BudgetAllocationControls total={BuildStore.totalSize} userDetails={BuildStore.userDetails} allocationHandler={this.allocationHandler.bind(this)} totalHandler={this.onTotalInput.bind(this)}
									></BudgetAllocationControls>
								</Paper>
								<Paper zDepth={2} style={paperStyle} >
							   		<h5 style={leftTitleStyle}>
							   			Select Sectors:
						   			</h5>
								    <GridList style={gListStyle}
									      cellHeight={30}
									      cols={3}
									      padding={12}
									    >
									    {rButtons}
					    			</GridList>
								</Paper>
								<Paper zDepth={2}  style={styles.create_paper}>

									<div style={{display:'flex', marginTop:'10px'}}>
										<RaisedButton style={styles.updateTeamButton} label="UPDATE CURRENT TEAM" onClick={this.updateTeam.bind(this)}></RaisedButton>

			            	            <div style={styles.periodSelectText} >Update Period: </div>
	        	           	            <DropDownMenu style={styles.monthsDropdown} onChange={this.changePeriod.bind(this)} value={BuildStore.userDetails.teamUpdatePeriod} >
	        	           		           {periodOpt}
	        	           	            </DropDownMenu>

        	           	            </div>
								</Paper>

							</div>
							<div style={styles.rightCol}>
								{/* <UserDetails style={{width: '98.3%',marginBottom: 10}}  userDetails={BuildStore.userDetails}/> */}
								<SectorsPie style={styles.sectorsPie} chartSeries= {BuildStore.sectors} data={BuildStore.sectors} total={BuildStore.totalSize}/>
							</div>
						</div>
						<SectorsTable save={this.editSector} userDetails={BuildStore.userDetails} totalBudget={BuildStore.totalSize} sectors={BuildStore.sectors} style={styles.sectorsTable} />
						<ErrorView style={errorsStyle} errors={this.state.errors} alerts={this.state.alerts}/>
						<h5 style={bigTitleStyle}>Sectors Settings</h5>
						<hr style={hrStyle}/>
						<div style={styles.cardsContainer}>
							<div style={styles.sectorsList}>
								{sectorCards}
							</div>
						</div>
					</div>
					<div style={styles.backtestArea}>

						<BacktestModule backtestStatusMsg={BuildStore.backtestStatusMsg} backtestStatusCode={BuildStore.backtestStatusCode}
										backtestResponse={BuildStore.backtestResponse} BuildStore={BuildStore} closeBacktest={this.closeBacktest.bind(this)}/>
					</div>
					<div style={styles.buildFooter}>
						<FlatButton style={styles.bTButton} label="backtest" onClick={this.openBacktest.bind(this)}></FlatButton>
						<FlatButton style={styles.sButton} label="save" onClick={this.editSectors.bind(this)}></FlatButton>
					</div>
					<NotificationSystem ref="notificationSystem" />
				</div>
			);
		}

	}

}



// WEBPACK FOOTER //
// ./src/js/pages/Build.js